<template>
  <b-modal
    v-model="showModal"
    :title="title"
    modal-class="modal-primary"
    hide-footer
    @hidden="$emit('hidden')"
    size="xl"
    scrollable
    no-close-on-backdrop
  >
    <b-row class="mb-1 d-flex justify-content-end align-items-center">
      <b-col cols="1">
        <b-form-select
          v-model="anioSeleccionado"
          :options="anios"
          @change="getCalendarioVacaciones"
        >
        </b-form-select>
      </b-col>
    </b-row>

    <b-row class="modal-reprogramar-vacaciones">
      <b-col cols="12">
        <b-table
          sticky-header="75vh"
          hover
          :items="items"
          :fields="vacaciones_calendario_fields"
          show-empty
          empty-text="No hay vacaciones disponibles para reprogramar"
          responsive
          primary-key="id"
        >
          <template #cell(empleado)="data">
            <router-link
              target="_blank"
              :class="[textLink]"
              :to="{
                name: 'rrhh-employees-information',
                params: { id: data.item.id },
              }"
            >
              <feather-icon
                v-if="data.item.personal_type == 'Driver'"
                icon="TruckIcon"
                size="16"
                class="text-warning"
              />
              <feather-icon
                v-else
                icon="UserIcon"
                size="16"
                class="text-success"
              />
              {{ data.item.empleado | capitalize }} </router-link
            ><br />
            <span style="opacity: 0.7"> {{ data.item.area | capitalize }} </span
            ><br />
            <span style="opacity: 0.7" class="text-primary">
              {{ data.item.document_number | capitalize }}
            </span>
          </template>

          <template v-for="i in 12" v-slot:[`cell(mes_${i})`]="slotProps">
            <b-badge
              :key="i"
              :variant="
                slotProps.item['mes_' + i] > 0
                  ? 'light-success'
                  : 'light-secondary'
              "
              pill
              class="m-1"
            >
              {{ slotProps.item["mes_" + i] }}
            </b-badge>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import VacacionesService from "@/views/rrhh/views/payroll/components/vacaciones/service/vacaciones.service.js";
import { vacaciones_calendario_fields } from "@/views/rrhh/views/payroll/components/vacaciones/data/vacaciones.programadas.fields.js";

export default {
  data() {
    const currentYear = new Date().getFullYear();
    return {
      vacaciones_calendario_fields,
      showModal: true,
      items: [],
      anioSeleccionado: currentYear,
      anios: Array.from({ length: currentYear - 2020 + 1 }, (_, i) => 2020 + i),
    };
  },
  computed: {
    title() {
      return `REPORTE VACACIONES`;
    },
  },
  mounted() {
    this.getCalendarioVacaciones();
  },
  methods: {
    async getCalendarioVacaciones() {
      try {
        this.addPreloader();
        const { data } = await VacacionesService.getCalendarioVacaciones({
          anio: this.anioSeleccionado,
        });

        // Transformar vacaciones_por_mes en columnas por mes
        this.items = data.map((row) => {
          let meses = {};
          for (let i = 1; i <= 12; i++) {
            const vacMes = row.vacaciones_por_mes.find((v) => v.mes === i);
            meses["mes_" + i] = vacMes ? vacMes.cantidad_vacaciones : 0;
          }
          return {
            id: row.id,
            empleado: row.empleado, // <--- aquí
            personal_type: row.personal_type, // <--- aquí
            document_number: row.document_number, // <--- aquí
            area: row.area, // <--- si quieres mostrar el área
            ...meses,
          };
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>
